var _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 369,
    viewBox: "0 0 369 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 184.5,
    r: 177.5,
    stroke: "white",
    strokeWidth: 14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 184.5,
    r: 137.5,
    stroke: "white",
    strokeWidth: 14
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 184.5,
    r: 89.5,
    stroke: "white",
    strokeWidth: 14
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 184.5,
    r: 53.5,
    stroke: "white",
    strokeWidth: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchTarget);
export default __webpack_public_path__ + "static/media/arch-target.ddff8c15dfe688b5d6f998c1670dcf65.svg";
export { ForwardRef as ReactComponent };